const message = {
    addText: "Add",
    addSomeThing: "Add {label}",
    delText: "Delete",
    selectedTextAdvanced: "Selected",
    delConfirm: "Are you sure you want to delete this {name}?",
    defaultInputPlaceholder: "Please enter {label}",
    defaultSelectPlaceholder: "Please select {label}",
    startDate: "Start Date",
    endDate: "End Date",
    soFarText: "Hitherto",
    uploadButtonText: "Click Upload",
    uploadTips: "Support extension {extensionNames}, single file size does not exceed {fileSize} M, upload up to {maxLength} attachments",
    yuan: "yuan",
    thousand: "ten thousand yuan",
    salaryType: "Salary type",
    Cancel: "Cancel",
    Save: "Save",
    Next: "Next",
    Complete: "Complete",
    Crop: "Crop",
    Preview: "Preview",
    PictureFormat: "Picture Format: ",
    ImageSize: "Image Size: ",
    ReUpload: "Re-upload",
    UploadFailed: "Upload Failed{msg}",
    NotExceeding: "Not exceeding {size}M",
    FileNotExceeding: "File {name} not exceeding {size}MB！",
    Rotate: "Rotate",
    ImageFull: "Image Full",
    Size: "Image Size",
    Sign: "Sign",
    ClickSign: "Click Sign",
};

export default message;
